<ion-toolbar>
  <h3 style="margin-left: 15px">Snooze</h3>
</ion-toolbar>

<ion-list [hidden]="isCustom">
  <ion-item (click)="snooze20Minutes()" button="true" class="ion-item-rounded">
    <ion-label text-wrap>20 minutes</ion-label>
  </ion-item>
  <ion-item (click)="snoozeOneHour()" button="true" class="ion-item-rounded">
    <ion-label text-wrap>1 hour</ion-label>
  </ion-item>
  <ion-item (click)="snoozeLaterToday()" button="true" *ngIf="showLaterToday" class="ion-item-rounded">
    <ion-label text-wrap>Later today</ion-label>
  </ion-item>
  <ion-item (click)="snoozeTomorrow()" button="true" class="ion-item-rounded">
    <ion-label text-wrap>Tomorrow</ion-label>
  </ion-item>
  <ion-item (click)="snoozeNextWeek()" button="true" class="ion-item-rounded">
    <ion-label text-wrap>Next week</ion-label>
  </ion-item>
  <ion-item (click)="snoozeTwoWeeks()" button="true" class="ion-item-rounded">
    <ion-label text-wrap>Two weeks</ion-label>
  </ion-item>
  <ion-item (click)="snoozeNextMonth()" button="true" class="ion-item-rounded">
    <ion-label text-wrap>Next month</ion-label>
  </ion-item>
  <ion-item (click)="snoozeTwoMonths()" button="true" class="ion-item-rounded">
    <ion-label text-wrap>Two months</ion-label>
  </ion-item>
  <ion-item (click)="isCustom = !isCustom" button="true" class="ion-item-rounded">
    <ion-label text-wrap>Custom</ion-label>
  </ion-item>
</ion-list>

<div *ngIf="isCustom" style="padding: 15px; background: var(--ion-item-background)">
  <app-datetime-picker
    [initialDate]="getInitialDate()"
    [initialTime]="getInitialTime()"
    (datetimeChanged)="setSnoozeDate($event)"
  >
  </app-datetime-picker>
  <div style="margin-top: 10px">
    <ion-button fill="clear" color="dark" (click)="isCustom = false">
      <ion-icon name="arrow-back-outline"></ion-icon> Back
    </ion-button>
    <ion-button fill="clear" color="dark" (click)="confirmSnooze()" class="button-dark-border"
      ><ion-icon name="checkmark"></ion-icon> Confirm
    </ion-button>
  </div>
</div>
